import {Box} from "@chakra-ui/react";

import {useNavigate} from "react-router-dom";
import {GalleryImage} from "~/utils/types.ts";
import {Product} from "~/store/gallerySlice.ts";
import GallerySelect from "~/apps/cartario/components/GallerySelect.tsx";

const MyImages = () => {

    const navigate = useNavigate();

    const onImageSelect = (image: GalleryImage | Product) => {
        navigate(`/c-panel/cartario/image/edit/${image.public_id}`)
    }

    return (
        <Box p={6} bg="gray.800" minH="100vh">
            <GallerySelect onImageSelect={onImageSelect} showOtherOptions={true} selectText="Edit" />
        </Box>
    );
}

export default MyImages;